export default __webpack_public_path__ + "static/media/half-circle.c0abcd6f.gif";